import React from 'react';
import LayoutContainer from './Container';
import Story from './NegligenceStory';
import '../styles/maincontent.css';

const Negligence = () => {
  const petitionURL = "https://petition.parliament.uk/petitions/660652";

  return (
    <LayoutContainer>
      <div className="main-content">
        <div className="content-row align-items-center">
          <a href={petitionURL} target="_blank" rel="noopener noreferrer" className="qr-image-container">
            <img src="images/qr-code.jpg" alt="QR Code" className="img-fluid qr-col" />
          </a>
          <h1 className="left-title">Professional negligence</h1>
        </div>
        {/* Professional negligence claim */}
        <Story />
      </div>
    </LayoutContainer>
  );
}

export default Negligence;

